module.exports = __webpack_public_path__ + "static/media/mail-and-phone-2562.13c4678e.svg";